module.exports = __webpack_public_path__ + "img/P150T_weapon_46.2907434c.png";